export default "__VITE_ASSET__6ba1da81__"